import { getTexts } from '@twnel/web-components';
import { SUCCESS_TYPE, ERROR_TYPE } from 'utils/toastDispacher';
import { toastDispacher } from 'utils';

const GLOBAL_FUNCTIONS_GETTER = 'GLOBAL_FUNCTIONS_GETTER';
const GLOBAL_FUNCTION_GETTER = 'GLOBAL_FUNCTION_GETTER';
const GLOBAL_FUNCTION_CREATION = 'GLOBAL_FUNCTION_CREATION';
const GLOBAL_FUNCTION_UPDATE = 'GLOBAL_FUNCTION_UPDATE';
const GLOBAL_FUNCTION_DELETION = 'GLOBAL_FUNCTION_DELETION';

const networkError = (error) => {
  if (!(error instanceof Error)) {
    return new Error(error);
  }
  return { ...error, name: 'TwnelNetwork' };
};

const throwNetworkError = (error) => {
  throw networkError(error);
};

/**
 * Obtener todas las funciones globales de la compañía
 */
export const fetchGlobalFunctions = () => (dispatch, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.list()
    .then((functions) => {
      // Convertir el array de funciones a un objeto con el nombre como key
      const functionsObject = functions.reduce((acc, func) => {
        acc[func.name] = func;
        return acc;
      }, {});
      return functionsObject;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTIONS_GETTER, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Obtener una función global específica por nombre
 */
export const fetchGlobalFunction = (functionName) => (dispatch, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.get(functionName)
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_GETTER, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Crear una nueva función global
 */
export const createGlobalFunction = (functionName, functionData) => (_, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.create(functionName, functionData)
    .then((newFunction) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_CREATION, texts, type: SUCCESS_TYPE });
      return newFunction;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_CREATION, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Actualizar una función global existente
 */
export const updateGlobalFunction = (functionName, functionData) => (_, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.update(functionName, functionData)
    .then((updatedFunction) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_UPDATE, texts, type: SUCCESS_TYPE });
      return updatedFunction;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_UPDATE, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};

/**
 * Eliminar una función global
 */
export const deleteGlobalFunction = (functionName) => (_, getState, getContext) => {
  const { api } = getContext();
  const texts = getTexts(getState());

  return api.functions.delete(functionName)
    .then(() => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_DELETION, texts, type: SUCCESS_TYPE });
      return true;
    })
    .catch((error) => {
      toastDispacher({ actionId: GLOBAL_FUNCTION_DELETION, texts, type: ERROR_TYPE });
      throwNetworkError(error);
    });
};
